import validate from "/builds/webcontact/borsdorf/node_modules/nuxt/dist/pages/runtime/validate.js";
import layout from "/builds/webcontact/borsdorf/node_modules/@webcontact/nuxt-kommunen/dist/runtime/middleware/page.mjs";
import manifest_45route_45rule from "/builds/webcontact/borsdorf/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  layout,
  manifest_45route_45rule
]
export const namedMiddleware = {}